import styled from "styled-components";
import { color } from "../../styles";
import { TextareaAutosize } from "@mui/material";

export const StyledTextArea = styled(TextareaAutosize)`
    border-radius: 8px;
    border: 1px solid #ccd5df;
    height: 100%;
    padding: 8px 16px;
    resize: none;

    font-family: Noto Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;

    &::placeholder {
        color: ${color.emphasis.NEUTRAL_N30};
    }

    &:focus {
        border: 1px solid ${color.primary.BLUE_B100};
        box-shadow: none;
        outline: none;
    }
`;


export const InfoBoxWrapper = styled.div`
    background-color: white;
    border-radius: 5px;
    min-height: fit-content;
    border: 1px solid ${color.secondary.BORDER};
    box-shadow: none;
    height: auto;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 24px;

    .text {
        font-family: Noto Sans;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
`;

export const InfoBoxTitle = styled.div`
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
`;

